import {
  alarmModelToUpdateData,
  updateAlarmMutation,
} from '@akin-home/alarms/frontend';
import {
  alertModelToUpdateData,
  updateAlertMutation,
} from '@akin-home/alerts/frontend';
import { CalendarItemType } from '@akin-home/amplify';
import {
  eventModelToUpdateData,
  updateEventMutation,
} from '@akin-home/events/frontend';
import {
  mealModelToUpdateGraphql,
  updateMealMutation,
} from '@akin-home/meals/frontend';
import { CalendarItemUnion } from '../types';

/** This funciton can delete any calendar item */
export const updateCalendarItem = async <T extends CalendarItemUnion>(
  item: T
) => {
  switch (item.type) {
    case CalendarItemType.Event:
      return updateEventMutation({
        input: await eventModelToUpdateData(item),
      });
    case CalendarItemType.Alert:
      return updateAlertMutation({
        input: await alertModelToUpdateData(item),
      });
    case CalendarItemType.Alarm:
      return updateAlarmMutation({
        input: await alarmModelToUpdateData(item),
      });
    case CalendarItemType.Meal:
      return updateMealMutation({
        input: await mealModelToUpdateGraphql(item),
      });
    default:
      return undefined;
  }
};
